<div class="form-inline">
  <div class="row">
    <div class="col-md-1">
      <label class="pull-left" style="margin-right: 15px">Buyer</label>
    </div>
    <div class="col-sm-6 col-md-4 form-group mb-35">
      <ps-ui-select-dropdown
        [dropdownItems]="buyers"
        [field]="'name'"
        [enableSearch]="true"
        labelNone="Select Buyer"
        [label]="selectedBuyer?.name"
        (selectedItem)="selectBuyer($event)"
      >
      </ps-ui-select-dropdown>
    </div>
  </div>

  <div class="well" *ngIf="selectedBuyer">
    <div class="row justify-content-center">
      <div class="col-md-4 col-md-offset-4 row-width">
        <div class="row">
          <div class="col-xs-12">
            <h4 class="text-uppercase text-center mar35">
              {{ selectedBuyer.name }}
            </h4>
          </div>
          <div class="col-xs-12">
            <div class="softlaunch-toggle-btn config-tab">
              <label>Select All</label>
              <label class="status pull-right">
                <ps-ui-slider
                  (selectedChange)="updateConfigSettings('selectAll')"
                  [selected]="selectedBuyerConfig['selectAll']"
                ></ps-ui-slider>
              </label>
            </div>
          </div>
          <div class="col-xs-12" *ngFor="let config of configFields">
            <div
              class="softlaunch-toggle-btn config-tab"
              *ngIf="!config.parent && !config.hide"
            >
              <label>{{ config.name }}</label>
              <div class="setting-info">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
                <p
                  style="white-space: normal"
                  [innerHTML]="config.desc | safeHtml"
                ></p>
              </div>
              <label class="status pull-right">
                <ps-ui-slider
                  (selectedChange)="
                    updateConfigSettings(config.value, config.hasAdditionalInfo)
                  "
                  [selected]="selectedBuyerConfig[config.value]"
                  [disabled]="config.disabled"
                ></ps-ui-slider>
              </label>
              <div
                *ngIf="
                  isParent(config.value) && selectedBuyerConfig[config.value]
                "
              >
                <div *ngFor="let configWithParent of configFields">
                  <div
                    class="softlaunch-toggle-btn config-tab"
                    *ngIf="
                      !configWithParent.hide &&
                      configWithParent.parent &&
                      configWithParent?.parentValue === config.value
                    "
                  >
                    <label style="padding-left: 18px">{{
                      configWithParent.name
                    }}</label>
                    <div class="setting-info">
                      <i class="fa fa-info-circle" aria-hidden="true"></i>
                      <p style="white-space: normal">
                        {{ configWithParent.desc }}
                      </p>
                    </div>
                    <label class="status pull-right">
                      <ps-ui-slider
                        (selectedChange)="
                          updateConfigSettings(configWithParent.value)
                        "
                        [selected]="selectedBuyerConfig[configWithParent.value]"
                        [disabled]="configWithParent.disabled"
                      ></ps-ui-slider>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
